import { render, staticRenderFns } from "./feature2.vue?vue&type=template&id=2ac75770&scoped=true&"
import script from "./feature2.vue?vue&type=script&lang=js&"
export * from "./feature2.vue?vue&type=script&lang=js&"
import style0 from "./feature2.vue?vue&type=style&index=0&id=2ac75770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac75770",
  null
  
)

export default component.exports